<div [class]="'c-eventProgress-bar c-eventProgress-bar--' + classes.join(' ')">
  <span class="c-eventProgressBar__left-icon">
    <ng-content select="[eventProgressBarIcon] [eventProgressBarIconPos=left]"></ng-content>
  </span>

  <div class="c-progress">
    <div class="c-progress__track">
      <div class="c-progress__fill"></div>
    </div>
  </div>

  <div class="position-absolute t-0">
    <ng-content select="[eventProgressBar]"></ng-content>
  </div>

  <div class="c-eventProgress__container">
    <div class="c-eventProgress__intervals">
      @for (item of eventProgressBarData; track item.points; let i = $index) {
        <div class="interval">
          <div class="interval-top">
            <ng-container *ngTemplateOutlet="intervalTemplate; context: { item: item, position: i }"></ng-container>
          </div>

          <span class="item-points">{{ item.points | number: '1.0-0' : ('common.culture' | translate) }}</span>
        </div>
      }
    </div>
  </div>

  <span class="c-eventProgressBar__right-icon">
    <ng-content select="[eventProgressBarIcon] [eventProgressBarIconPos=right]"></ng-content>
  </span>
</div>
